import {createApp} from 'vue'
import Store from 'store'
import options from './SiteNavigation.options'
import MegaMenu from './SiteNavigationMegaMenu.vue'
import SearchMenu from './SiteNavigationSearchMenu.vue'
import Overlay from './SiteNavigationOverlay.options'
import parseMenuAsJson from './methods/scrapers'

const el = '.nlx-component--site-navigation'
const DOM = document.querySelector(el)
const component = createApp(options).use(Store)

const megaMenuEl = '.nlx-component--mega-menu'
const megaMenuDOM = document.querySelector(megaMenuEl)
const megaMenuComponent = createApp(MegaMenu).use(Store)

const searchMenuEl = '.nlx-component--search-menu'
const searchMenuDOM = document.querySelector(searchMenuEl)
const searchMenuComponent = createApp(SearchMenu).use(Store)

if (searchMenuDOM) {
    Store.commit('main/set_search_page_url',searchMenuDOM.dataset.searchpageurl)
}

const overlayEl = '.nlx-component--overlay'
const overlayDOM = document.querySelector(overlayEl)
const overlayComponent = createApp(Overlay).use(Store)


if(DOM && megaMenuDOM && overlayDOM && searchMenuDOM){

    const megaMenuData = parseMenuAsJson(DOM)

    Store.commit('main/set_mega_menu_data',megaMenuData)

    const template = DOM.innerHTML
    options.template = template
    
    component.mount(el)

    overlayDOM.classList.add('nlx-overlay')
    overlayDOM.querySelector('.nlx-overlay__void').setAttribute('v-on:click','callbackOnRemove')
    overlayComponent.mount(overlayEl)
    megaMenuDOM.classList.add('nlx-site-navigation__mega-menu')
    megaMenuComponent.mount(megaMenuEl)
    searchMenuDOM.classList.add('nlx-site-navigation__mega-menu','nlx-site-navigation__mega-menu__search-menu')
    searchMenuComponent.mount(searchMenuEl)

} else {
    console.error('SiteNavigation not loading: Missing part of the menu.','Has DOM:',!!DOM,'Has megaMenuDOM',!!megaMenuDOM,'Has overlayDOM',!!overlayDOM,'Has searchMenuDOM',!!searchMenuDOM)
}

